module.exports = __webpack_public_path__ + "de77a722/img/copy-icon.408fdb2d.svg";